import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import axios from 'axios';

const ReferidosPendientesWidget = () => {
  const navigate = useNavigate();
  const { user, API } = useContext(AuthContext);
  const [pendientesCount, setPendientesCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && user.rol === 'admin') {
      loadPendientesCount();
      
      // Actualizar cada 30 segundos
      const interval = setInterval(loadPendientesCount, 180000); // 3 minutos (antes 30 seg)
      return () => clearInterval(interval);
    }
  }, [user]);

  const loadPendientesCount = async () => {
    try {
      const response = await axios.get(`${API}/admin/referidos`);
      const referidos = response.data.referidos || [];
      // Contar solo los pendientes (que no han sido otorgados denarios)
      const pendientes = referidos.filter(r => !r.denarios_otorgados).length;
      setPendientesCount(pendientes);
    } catch (error) {
      console.error('Error al cargar referidos pendientes:', error);
      setPendientesCount(0);
    } finally {
      setLoading(false);
    }
  };

  // Solo mostrar si es admin y hay referidos pendientes
  if (loading || pendientesCount === 0 || user?.rol !== 'admin') {
    return null;
  }

  return (
    <div
      onClick={() => navigate('/app/gestion-referidos')}
      className="group relative bg-gradient-to-br from-green-500 via-emerald-500 to-teal-600 rounded-2xl p-6 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl overflow-hidden h-56"
    >
      {/* Efecto de brillo animado */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
      
      {/* Contenido */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-white px-2">
        {/* Ícono con animación */}
        <div className="mb-2 transform group-hover:scale-110 transition-transform duration-300">
          <div className="relative">
            <i className="fas fa-users text-4xl drop-shadow-lg" />
            {pendientesCount > 0 && (
              <div className="absolute -top-1 -right-1 bg-white text-green-600 rounded-full w-6 h-6 flex items-center justify-center font-bold text-xs shadow-lg animate-pulse">
                {pendientesCount > 99 ? '99+' : pendientesCount}
              </div>
            )}
          </div>
        </div>

        {/* Número grande */}
        <div className="text-5xl font-black mb-1 drop-shadow-lg">
          {pendientesCount > 99 ? '99+' : pendientesCount}
        </div>

        {/* Texto descriptivo */}
        <div className="text-center text-sm font-semibold drop-shadow">
          {pendientesCount === 1 ? 'Referido Nuevo' : 'Referidos Nuevos'}
        </div>
        <div className="text-center text-xs opacity-90 mt-1 drop-shadow">
          Pendiente de Pago
        </div>

        {/* Indicador de acción */}
        <div className="mt-3 text-xs opacity-75 group-hover:opacity-100 transition-opacity">
          <i className="fas fa-arrow-right mr-1" />
          Click para gestionar
        </div>
      </div>

      {/* Efecto de pulso en el fondo */}
      <div className="absolute inset-0 bg-white/10 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
    </div>
  );
};

export default ReferidosPendientesWidget;
